import type {
  CandidateAssociationTag,
  CandidateAssociationTagMap,
} from "@/types/vacancy"

const normalizeSlugValue = (slug: string): string => slug.replace(/-s-w/g, "-sw")

export const slugifyTagLabel = (label?: string | null): string => {
  if (!label) {
    return ""
  }
  const slug = label
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
  return normalizeSlugValue(slug)
}

export type CombinedCandidateTag = {
  slug: string
  label: string
  source?: string | null
}

export const combineAssociationTags = (
  tagsJson?: CandidateAssociationTagMap | null,
  legacyTags?: CandidateAssociationTag[] | null
): CombinedCandidateTag[] => {
  const map = new Map<string, CombinedCandidateTag>()

  if (tagsJson) {
    Object.entries(tagsJson).forEach(([slug, entry]) => {
      if (!entry || typeof entry.label !== "string") {
        return
      }
      if (entry.suppressed) {
        return
      }
      const normalizedSlug = slug
        ? normalizeSlugValue(slug.trim().toLowerCase())
        : slugifyTagLabel(entry.label)
      if (!normalizedSlug) {
        return
      }
      const label = entry.label.trim().length > 0 ? entry.label.trim() : normalizedSlug
      map.set(normalizedSlug, {
        slug: normalizedSlug,
        label,
        source: entry.source ?? null,
      })
    })
  }

  if (legacyTags) {
    legacyTags.forEach((tag) => {
      const candidateLabel = tag.label?.trim()
      const slug = slugifyTagLabel(tag.slug ?? candidateLabel ?? "")
      if (!slug || map.has(slug)) {
        return
      }
      map.set(slug, {
        slug,
        label: candidateLabel && candidateLabel.length > 0 ? candidateLabel : slug,
        source: "legacy",
      })
    })
  }

  return Array.from(map.values())
}
